import { TFunction } from 'i18next';
import * as yup from 'yup';

export interface OnvifViewModel {
  discovery: boolean;
  location: string[];
}

export interface OnvifResponse {
  data: OnvifViewModel;
}

/*
 * Yup validation schema
 */
export const onvifValidationSchema = (_t: TFunction) =>
  yup.object<OnvifViewModel>().shape({
    location: yup.array().of(yup.string()),
  });
